<p-dropdown
  [options]="dropdownOptions"
  [(ngModel)]="selectedOption"
  optionLabel="label"
  optionValue="value"
  placeholder="Select"
  styleClass="{{ styleClass }}"
  panelStyleClass="select-dropdown-panel {{ additionalPanelStyleClass }}"
  [showClear]="selectedOption ? showClearFlag : false"
  appendTo="body"
  (onChange)="onDopdownChange()"
  optionDisabled="isDisabled"
  [readonly]="isReadonlyMode"
  [disabled]="isDisabled"
>
  <ng-template let-option pTemplate="item">
    <div [ngClass]="{ 'create-new-option': option.value === 'create-new' }">
      {{ option.label | translate }}
    </div>
  </ng-template>
  <ng-template let-option pTemplate="selectedItem">
    {{ option.label | translate }}
  </ng-template>
</p-dropdown>
